import { Controller } from "@hotwired/stimulus"

// Aggiunge/rimuove domande personalizzate nel form del tipo di prenotazione.
// A differenza di booking-schedule, le domande non sono record ActiveRecord:
// rimuovere una riga significa semplicemente eliminarne gli input dal DOM.
export default class extends Controller {
  static targets = ["template", "list"]

  addRow() {
    const index = new Date().getTime() + this.#counter()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  removeRow(event) {
    event.currentTarget.closest("[data-booking-questions-target='row']").remove()
  }

  #counter() {
    this.count = (this.count || 0) + 1
    return this.count
  }
}
